/* DOZZ theme interactions — faithful port of the Next.js behaviors, on top of Shopify's AJAX cart. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = window.Shopify && Shopify.formatMoney ? null : null; // we format from cart JSON strings

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Generic drawer open/close ---------- */
  function bindDrawer(rootSel, openSels, closeSels) {
    var root = document.querySelector(rootSel);
    if (!root) return null;
    function open() { root.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function close() { root.classList.remove('open'); document.body.style.overflow = ''; }
    (openSels || []).forEach(function (s) {
      document.querySelectorAll(s).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    });
    root.querySelectorAll('[data-close], .menu-backdrop, .search-backdrop, .cd-backdrop').forEach(function (b) {
      b.addEventListener('click', close);
    });
    (closeSels || []).forEach(function (s) {
      document.querySelectorAll(s).forEach(function (b) { b.addEventListener('click', close); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return { open: open, close: close, root: root };
  }

  /* ---------- Search filter ---------- */
  function initSearch(searchDrawer) {
    var input = document.querySelector('.search-input');
    if (!input) return;
    var results = Array.prototype.slice.call(document.querySelectorAll('.search-result'));
    var empty = document.querySelector('.search-empty');
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      results.forEach(function (r) {
        var hay = (r.getAttribute('data-search') || '').toLowerCase();
        var match = !q || hay.indexOf(q) !== -1;
        r.classList.toggle('search-hidden', !match);
        if (match) shown++;
      });
      if (empty) empty.style.display = shown === 0 ? '' : 'none';
    });
    if (searchDrawer) {
      var loupe = document.querySelector('[data-open-search]');
      if (loupe) loupe.addEventListener('click', function () { setTimeout(function () { input.focus(); }, 40); });
    }
  }

  /* ---------- Cart helpers ---------- */
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function pulseCartIcon() {
    var target = document.querySelector('[data-cart-icon]');
    if (!target) return;
    target.classList.remove('cartPulse');
    void target.offsetWidth;
    target.classList.add('cartPulse');
    setTimeout(function () { target.classList.remove('cartPulse'); }, 420);
  }

  var toastTimer = null;
  function showToast(text) {
    var region = document.querySelector('.toast-region');
    if (!region) return;
    if (toastTimer) clearTimeout(toastTimer);
    region.innerHTML = '';
    var t = document.createElement('div');
    t.className = 'toast';
    t.textContent = text;
    region.appendChild(t);
    toastTimer = setTimeout(function () { region.innerHTML = ''; }, 1800);
  }

  function fly(imageSrc, from) {
    if (reduce) return;
    var cartIcon = document.querySelector('[data-cart-icon]');
    var layer = document.querySelector('.fly-layer');
    if (!cartIcon || !layer || !imageSrc) { pulseCartIcon(); return; }
    var target = cartIcon.getBoundingClientRect();
    var size = 64;
    var img = document.createElement('img');
    img.src = imageSrc; img.alt = ''; img.className = 'flyer';
    img.style.width = size + 'px'; img.style.height = size + 'px';
    var startX = from.left + from.width / 2 - size / 2;
    var startY = from.top + from.height / 2 - size / 2;
    var endX = target.left + target.width / 2 - size / 2;
    var endY = target.top + target.height / 2 - size / 2;
    layer.appendChild(img);
    if (typeof img.animate !== 'function') { img.remove(); pulseCartIcon(); return; }
    var anim = img.animate([
      { transform: 'translate(' + startX + 'px,' + startY + 'px) scale(1)', opacity: 1 },
      { transform: 'translate(' + ((startX + endX) / 2) + 'px,' + (startY - 40) + 'px) scale(.7)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + endX + 'px,' + endY + 'px) scale(.25)', opacity: 0.2 }
    ], { duration: 750, easing: 'cubic-bezier(.16,1,.3,1)' });
    anim.onfinish = function () { anim.cancel(); img.remove(); pulseCartIcon(); };
    anim.oncancel = function () { img.remove(); };
  }

  function updateBadges(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function renderDrawer(cart) {
    var body = document.querySelector('.cd-body');
    var footTotal = document.querySelector('[data-cd-total]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="cd-empty">Ton panier est vide pour l\'instant. ✦</p>';
    } else {
      body.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
        return '<div class="cd-line" data-key="' + it.key + '">' +
          '<div class="cd-thumb">' + img + '</div>' +
          '<div><div class="cd-name">' + it.product_title + '</div>' +
          '<div class="cd-sub">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + '</div>' +
          '<div class="cd-price">' + fmt(it.final_line_price) + '</div>' +
          '<button type="button" class="cd-remove" data-remove="' + it.key + '">Retirer</button></div>' +
          '<div class="qty"><button type="button" data-cd-dec="' + it.key + '">−</button><span>' + it.quantity + '</span><button type="button" data-cd-inc="' + it.key + '">+</button></div>' +
          '</div>';
      }).join('');
    }
    if (footTotal) footTotal.textContent = fmt(cart.total_price);
    bindDrawerLineEvents();
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function bindDrawerLineEvents() {
    document.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { changeLine(b.getAttribute('data-remove'), 0).then(afterCartChange); });
    });
    document.querySelectorAll('[data-cd-inc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var line = b.closest('.cd-line'); var q = parseInt(line.querySelector('.qty span').textContent, 10) + 1;
        changeLine(b.getAttribute('data-cd-inc'), q).then(afterCartChange);
      });
    });
    document.querySelectorAll('[data-cd-dec]').forEach(function (b) {
      b.addEventListener('click', function () {
        var line = b.closest('.cd-line'); var q = parseInt(line.querySelector('.qty span').textContent, 10) - 1;
        changeLine(b.getAttribute('data-cd-dec'), Math.max(0, q)).then(afterCartChange);
      });
    });
  }

  function afterCartChange(cart) {
    updateBadges(cart.item_count);
    renderDrawer(cart);
  }

  /* ---------- Add to cart ---------- */
  function addToCart(variantId, qty, imageSrc, originRect) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () {
      showToast('Ajouté au panier ✦');
      fly(imageSrc, originRect);
      return getCart().then(afterCartChange);
    });
  }

  function initAddButtons() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var qtyInput = btn.closest('[data-buy]') ? btn.closest('[data-buy]').querySelector('[data-qty-value]') : null;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var imageSrc = btn.getAttribute('data-image');
        // origin rect: prefer the product image near the button
        var originImg =
          (btn.closest('article') && btn.closest('article').querySelector('img')) ||
          (btn.closest('.pdp') && btn.closest('.pdp').querySelector('.gmain img')) ||
          (btn.closest('.flag') && btn.closest('.flag').querySelector('.podium img'));
        var from = (originImg || btn).getBoundingClientRect();
        addToCart(variantId, qty, imageSrc, from);
      });
    });
  }

  /* ---------- Qty steppers (PDP) ---------- */
  function initQtySteppers() {
    document.querySelectorAll('[data-qty]').forEach(function (q) {
      var valueEl = q.querySelector('[data-qty-display]');
      var input = q.querySelector('[data-qty-value]');
      var dec = q.querySelector('[data-qty-dec]');
      var inc = q.querySelector('[data-qty-inc]');
      function set(n) { n = Math.max(1, n); if (input) input.value = n; if (valueEl) valueEl.textContent = n; }
      if (dec) dec.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
      if (inc) inc.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
    });
  }

  /* ---------- Cart page (full) qty/remove ---------- */
  function initCartPage() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;
    page.querySelectorAll('[data-line-key]').forEach(function (row) {
      var key = row.getAttribute('data-line-key');
      var dec = row.querySelector('[data-qty-dec]');
      var inc = row.querySelector('[data-qty-inc]');
      var disp = row.querySelector('[data-qty-display]');
      var rm = row.querySelector('[data-line-remove]');
      function change(q) { changeLine(key, q).then(function () { window.location.reload(); }); }
      if (dec) dec.addEventListener('click', function () { change(Math.max(0, parseInt(disp.textContent, 10) - 1)); });
      if (inc) inc.addEventListener('click', function () { change(parseInt(disp.textContent, 10) + 1); });
      if (rm) rm.addEventListener('click', function () { change(0); });
    });
  }

  /* ---------- Influenceuses video modal ---------- */
  function bindInfluModal(modal) {
    var video = modal.querySelector('.influ-video');
    var closeBtn = modal.querySelector('.influ-close');
    if (!video || !closeBtn) return;
    // Triggers belonging to THIS section (supports multiple influ grids on a page).
    var scope = modal.closest('section') || document;
    var lastTrigger = null;

    function open(src, label) {
      lastTrigger = document.activeElement;
      if (label) modal.setAttribute('aria-label', 'Vidéo : ' + label);
      video.muted = false;            // sound MUST be audible (user gesture)
      video.src = src;
      video.currentTime = 0;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      closeBtn.focus();
    }
    function close() {
      if (modal.hidden) return;
      video.pause();
      video.currentTime = 0;
      video.removeAttribute('src');
      video.load();                   // fully stops audio
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    }

    scope.querySelectorAll('.influ-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(btn.getAttribute('data-video-src'), btn.getAttribute('data-video-alt'));
      });
    });
    closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {            // simple focus trap: close <-> video
        var f = [closeBtn, video];
        var i = f.indexOf(document.activeElement);
        e.preventDefault();
        var next = e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i >= f.length - 1 ? 0 : i + 1);
        f[next].focus();
      }
    });
  }
  function initInflu() {
    document.querySelectorAll('.influ-modal').forEach(bindInfluModal);
  }

  /* ---------- Sticky header: glassmorphism once the page is scrolled ---------- */
  function initStickyNav() {
    var nav = document.querySelector('.nav');
    if (!nav) return;
    var ticking = false;
    function update() { nav.classList.toggle('is-scrolled', window.scrollY > 8); ticking = false; }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Header height → CSS var (hero fills viewport minus header) ---------- */
  function setHeaderHeight() {
    var main = document.getElementById('main');
    var h = main ? main.getBoundingClientRect().top + window.scrollY : 100;
    document.documentElement.style.setProperty('--header-h', Math.round(h) + 'px');
  }

  document.addEventListener('DOMContentLoaded', function () {
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
    initReveal();
    initStickyNav();
    bindDrawer('.menu-root', ['[data-open-menu]'], []);
    var search = bindDrawer('.search-root', ['[data-open-search]'], []);
    initSearch(search);
    bindDrawer('.cd-root', ['[data-open-cart]'], []);
    initAddButtons();
    initQtySteppers();
    initCartPage();
    initInflu();
    getCart().then(function (cart) { updateBadges(cart.item_count); renderDrawer(cart); }).catch(function () {});
  });
})();
